import { Reveal } from "./Reveal";
import { Store, ArrowRight } from "lucide-react";
import { scrollToId } from "../lib/site";

const Showroom = () => (
  <section
    className="border-y border-bark/10 bg-sand/60 py-24 md:py-32"
    data-testid="showroom-section"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-start gap-10 px-5 md:flex-row md:items-center md:justify-between md:px-10">
      <Reveal className="max-w-2xl">
        <p className="mb-4 flex items-center gap-2 font-sans text-xs font-light uppercase tracking-[0.45em] text-clay">
          <Store size={14} /> E se ti serve il parquet?
        </p>
        <h2 className="font-display text-3xl font-medium leading-snug text-ink sm:text-4xl lg:text-5xl">
          Noi lo posiamo. Per il materiale, ti accompagniamo dai{" "}
          <em className="text-honey">nostri showroom partner</em> a Roma.
        </h2>
        <p className="mt-5 max-w-xl font-sans text-sm font-light leading-relaxed text-bark/80 md:text-base">
          Collaboriamo con alcuni showroom selezionati a Roma: scegli il
          parquet che ami con chi ti consigliamo noi, alla posa pensiamo noi.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <button
          onClick={() => scrollToId("sopralluogo")}
          data-testid="showroom-cta-button"
          className="group flex shrink-0 items-center gap-2 rounded-full border border-bark/40 px-7 py-3.5 font-sans text-sm font-medium text-ink transition-colors duration-300 hover:border-honey hover:bg-honey"
        >
          Parliamone al sopralluogo
          <ArrowRight
            size={15}
            className="transition-transform duration-300 group-hover:translate-x-1"
          />
        </button>
      </Reveal>
    </div>
  </section>
);

export default Showroom;
